module.exports = __webpack_public_path__ + "img/chasa_no.fa87f20b.png";